import {
    Accordion,
    AccordionDetails,
    AccordionSummary,
    Box,
    Button,
    Container,
    Typography,
  } from "@mui/material";

  import { Link, useNavigate } from "react-router-dom";
  import { useSelector } from "../store";

  import React, { useEffect } from "react";
  import plus from "../assets/images/website/plus.png";
  
  function WhatIsPovego() {
    const [expanded, setExpanded] = React.useState(false);
    const navigate = useNavigate()
    const { username } = useSelector((state) => state.auth);

    useEffect(() => {
      window.scrollTo(0, 0);
    }, []);
  
    const handleChange = (panel) => (event, isExpanded) => {
      setExpanded(isExpanded ? panel : false);
    };
    return (
      <React.Fragment>
        <Container maxWidth="xl">
            <Box
              sx={{
                maxWidth: "1400px",
                padding: {xs: '65px 0px 107px' , lg: "140px 0px"},
                margin: "auto",
                textAlign: "center",
              }}
            >
            
              

              <Typography
                sx={{
                  color: "#000",
                  fontWeight: 700,
                  fontFamily: '"Inter", sans-serif',
                  fontSize: { xs: 36, lg: 54 },
                  lineHeight: { xs: '44px', lg: "65px" },
                  maxWidth: '500px',
                  margin: { xs: 'auto', lg: 0 },
                  textAlign: { xs: 'center', lg: 'start' }
                }}
              >
               Povego Nedir?
              </Typography>
              <Typography
                sx={{
                  color: "#000",
                  fontWeight: 400,
                  fontFamily: '"Inter", sans-serif',
                  fontSize: { xs: 18, lg: 22 },
                  padding: "24px 0px 60px",
                  textAlign: { xs: 'center', lg: 'start' }
                }}
              >
              Povego, kripto varlık alım satımı yapabildiğiniz bir pazaryeridir.<br/><br/>
              Türkiye’nin blockchain tabanlı yatırım platformudur.<br/><br/>
              2023 yılında teknoloji ve finans dünyasından uzman bir ekip tarafından kuruldu.<br/><br/>
              Türkiye'nin önde gelen finans markalarına 6 yıldır finansal iletişim hizmeti veren, Türkiye’nin ilk Finansal İletişim Ajansı FİA'nın güçlü tecrübesi, Povego’nun mihenk taşı oldu. Finans dünyasına adım attığımızdan bu yana, sermaye piyasalarının baş aktörlerine sunduğumuz, iletişim ekosistemine ilham olan finansal iletişim danışmanlığı tecrübemizi, şimdi de Türkiye'de blockchain tabanlı yatırımları yaygınlaştırmak için başlattığımız Povego ile pekiştirdik. Povego olarak, geleceğin yatırım dünyasındaki öncü rolümüzü istikrarlı bir şekilde sürdürmeyi hedefliyoruz.<br/><br/>

              Yatırım dünyasında yeni bir çağ başlatıyoruz. Yenilikçi platformumuzla, yatırımcılarımıza daha güvenli, şeffaf ve erişilebilir bir yatırım ortamı sunuyoruz.<br/><br/>
			<strong>Güvenilir ve Şeffaf Kripto Varlık Platformu</strong><br/><br/>
              Povego'yu kurarken, temel amacımız kripto varlıkları dijital dünyaya güvenli, şeffaf ve spekülasyondan uzak bir şekilde taşımaktı. Povego, sahip olduğunuz kripto varlıkları alıp satmanın en güvenilir yoludur. <br/><br/>

              <strong>Öngörülebilir Yatırım Ortamı</strong><br/><br/>
			  Bizim için güven her şeyden önce geliyor. Bu önceliğe dayanarak spekülasyonların önüne geçmek ve güvenliği en üst düzeyde tutmak adına, platformumuzu sürekli olarak güncelliyor ve geliştiriyoruz. Böylece, Povego ekosisteminde her yatırımcının kendini güvende hissedeceği, şeffaf ve adil bir ticaret ortamı oluşturuyoruz. Povego'nun sağladığı bu güvenilir ve şeffaf ortam, yatırımcılarımıza destek verirken, varlık sahiplerine de yeni fırsatlar sunuyor.

              <strong>Bu Fırsatlar Neler Mi?</strong><br/><br/>
              
              Gerçek dünya varlıklarını tokenize ederek dijital dünyaya taşımak, varlıkların likiditesini önemli ölçüde artırır. Geleneksel yöntemlerle satış veya yatırım yapmak genellikle zaman alıcı ve karmaşık olabilir. Ancak, Povego ile bu süreçler hızlanır ve kolaylaşır. Tokenize edilmiş varlıklar, 7/24 işlem görebilir ve bu da yatırımcılara sürekli erişim imkânı sağlar. Ayrıca, tokenize edilen varlıklar, coğrafi sınırları aşarak daha geniş bir yatırımcı kitlesine ulaşır. Bu, varlık sahiplerinin uluslararası yatırımcılara erişimini kolaylaştırır ve potansiyel yatırımcı havuzunu genişletir. Sonuç olarak hem varlık sahipleri hem de yatırımcılar için daha dinamik ve erişilebilir bir yatırım ortamı oluşmuş olur.<br/><br/>
              
              <strong>Yatırım Dünyasında Yeni Bir Çağ</strong><br/><br/>
              
              Povego olarak, yatırım dünyasında yeni bir çağ başlatıyoruz. Yenilikçi platformumuzla, yatırımcılarımıza daha güvenli, şeffaf ve erişilebilir bir yatırım ortamı sunuyoruz. Hem bireysel hem de kurumsal yatırımcıların ihtiyaçlarını karşılamayı amaçlıyoruz. Şeffaflık ilkemizle, her adımda açık ve dürüst iletişimi ön planda tutuyoruz; güvenliğe verdiğimiz önemle, kullanıcılarımızın varlıklarını korumak için en son teknolojileri kullanıyoruz. Bu vizyonla, sadece bugün değil, gelecekte de daha büyük başarılara imza atacağımıza inanıyoruz. Yatırım dünyasında devrim niteliğinde değişimlere öncülük etmeye devam edecek ve daha geniş kitlelere ulaşarak büyümeyi sürdüreceğiz.<br/><br/>
              </Typography>
            </Box>
          </Container>
      </React.Fragment>
    );
  }
  
  export default WhatIsPovego;
  
